<ngx-loading [show]="isProcessing"></ngx-loading>

<section>
  <datalist id="listCentroCustos">
    <select>
      <option *ngFor="let item of centrosDeCusto" [value]="item.nome"></option>
    </select>
  </datalist>
</section>


<div class="row">
  <div class="col">

    <div class="box box-primary">

      <div class="box-header text-center">
        <h3 class="box-title">Acompanhar SS</h3><br />
      </div>

      <div class="divider"></div>
      <div class="box-body">

        <form novalidate [formGroup]="form" (ngSubmit)="submit(false)">

          <div class="form-row">

            <div class="col-md-3" [hidden]="!this.autorizacaoSpvOutrosUsuarios">
              <div class="form-group">
                <label for="">Usuário solicitante</label>
                <select class="form-control" id="usId" formControlName="usuarioSolicitouId">
                  <option value="0" selected>Todos</option>
                  <option *ngFor="let u of usuarios" value="{{ u.id }}">{{ u.nome }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="">Tipo de data</label>
                <select class="form-control" formControlName="tipoData">
                  <option value="DataHoraUltimoStatus" selected>Data do Status</option>
                  <option value="DataHoraCadastro">Data da emissão</option>
                </select>
              </div>
            </div>


            <div class="col-md-3">
              <div class="form-group">
                <label for="">Período Inicial</label>
                <input class="form-control" type="date" formControlName="dataInicial" id="dataInicial" max="2999-12-31">
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.hasError('dtInicioMuitoAntiga')">Data muito antiga</small>
                </section>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="">Período Final</label>
                <input class="form-control" type="date" formControlName="dataFinal" max="2999-12-31">
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.hasError('dtFinalMenorDtInicial')">Data Final deve ser maior que Data
                    Inicial
                  </small>
                  <small *ngIf="form.hasError('dtFinalMuitoAntiga')">Data muito antiga</small>
                </section>
              </div>
            </div>




          </div>

          <div class="form-row">

            <div class="col-md-4">
              <div class="form-group">
                <label for="">Status SS</label>
                <select formControlName="status" class="form-control"
                  (change)="changeStatus($event.target.selectedOptions[0].text)">
                  <option value="">Todos</option>
                  <option value="1">Aguardando Avaliação</option>
                  <option value="2">Aprovado</option>
                  <option value="3">Recusado</option>
                  <option value="4">OS Emitida</option>
                  <option value="5">Concluído</option>
                  <option value="6">Em Pendência</option>
                  <option value="7">OS Reprovada</option>
                </select>

              </div>
            </div>


            <div class="col-md-4">
              <div class="form-group">
                <label for="centroDeCusto">{{labelCentroCusto}}</label>
                <div class="input-group">
                  <input type="text" class="form-control" list="listCentroCustos" formControlName="centroCustoDescricao"
                    (change)="changeDataListCentroCustos($event.target.value)" maxlength="40" />
                  <div class="input-group-append cp" (click)="limparDataListCentroCustos()"
                    title="limpar campo e recarregar lista de opções">
                    <span class="input-group-text"><i class="fa fa-trash"></i></span>
                  </div>
                </div>
              </div>
            </div>



            <div class="col-md-2">
              <!--[disabled]="!this.autorizacao?.podeListar"-->
              <button type="submit" class="btn btn-primary btn-block btn-bottom btn-shadow"
                [disabled]="!this.form.valid || this.isProcessing"><i class="fa fa-search"></i></button>
            </div>

          </div>
        </form>

        <div class="divider"></div>

        <div class="box-table h400">

          <table>
            <thead>
              <tr>
                <th>Nº SS</th>
                <th>Serviço Solicitado</th>
                <th>Status SS</th>
                <th>Status OS</th>
                <th>Dt Hr Status</th>
                <th>Aprovado/Reprovado por</th>
                <th>Observação Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let spv of this.spvs" (click)="getSpvSelecionada(spv?.spvId, modal)">
                <td class="text-center">{{ spv?.spvId | zerosEsquerda : 5}}</td>
                <td class="mw280">{{ spv?.servico }}</td>
                <td *ngIf="spv?.osId == null" class="text-center">
                  <span class="badge badge-pill fw" [ngStyle]="{'background-color' : bgStatus[spv?.status]}">{{
                    spv?.statusStr }}
                  </span>
                </td>

                <td *ngIf="spv?.osId != null" class="text-center cp" (click)="showOS(spv?.osId, spv?.spvId)"
                  title="clique aqui para visualizar detalhes da OS {{spv?.osId}}">
                  <span class="badge badge-pill fw" [ngStyle]="{'background-color' : bgStatus[spv?.status]}">{{
                    spv?.statusStr }}
                    <span> - Nº {{spv?.osId}} </span>
                  </span>
                </td>

                <td class="text-center">
                  <span *ngIf="spv?.statusOS == null"></span>
                  <span *ngIf="spv?.statusOS != null" class="badge badge-pill fw"
                    [ngStyle]="{'background-color' : bgStatusOS[spv?.statusOS]}">
                    {{spv?.statusOSStr}}
                  </span>
                </td>

                <td class="text-center">{{ spv?.dataHoraUltimoStatus | date:'dd/MM/yyyy HH:mm' }}</td>
                <td class="text-center">{{ spv?.usuarioAprovouRecusou}}</td>
                <td class="mw280">{{ spv?.obsUltimoStatus }}</td>
              </tr>
              <tr *ngFor="let v of this.voids">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

      <div class="box-footer">
        <span *ngIf="this.spvs !== undefined && this.spvs?.length > 0" class="pl-2 pt-1 pb-2 animated fadeInDown">Total
          SSs pesquisadas :
          <b>{{ this.spvs?.length }}</b></span>
      </div>

    </div>
  </div>
</div>

<div class="row">
  <div class="col">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col-md-4">
            <app-ball-pulse *ngIf="isPesquisando"></app-ball-pulse>
          </div>

          <div class="col-md-4 mb-3">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
          <div class="col-md-2">
            <button class="mr-2 btn btn-outline-primary btn-shadow btn-block" (click)="reset()" type="button"><i
                class="fa fa-trash pull-left"></i>Limpar</button>
          </div>

          <div class="col-md-2">
            <button type="button" class="btn btn-primary btn-shadow btn-block"
              [disabled]="!this.form.valid || !this.autorizacoes.podeListar || this.spvs?.length == 0"
              (click)="imprimir()"><i class="fa fa-print pull-left"></i>Imprimir</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-detalhes-os [parameters]="this.parameters"></app-detalhes-os>